/**
 * Created by laugh on 12/18/2017.
 */
import React, { Component } from 'react';
import $ from 'jquery';
import logo from '../../assets/img/mealtrist-logo.png';
import { Link } from 'react-router-dom';
import MainHeader from '../header';
import MealtristHeader from '../Core/mealtristHeader';
import {FormGroup} from 'react-bootstrap';
import * as ReactBootstrap from 'react-bootstrap';
import StackGrid from "react-stack-grid";
import mealpic from '../../assets/img/mealtrist-featured-meal.jpg'
import '../../App.css';
import 'font-awesome/css/font-awesome.css';
import swal from 'sweetalert';
import sizeMe from 'react-sizeme';
import MealtristFooter from "../Core/mealtrist-footer";

class Saved extends React.Component {
    constructor(props) {
        super(props);
        this.state = {email: "", password: "", titleEdit: false, grid: "", meals: "", mealsToUpdate: [], mealToMoveClass: "", profile: "", category: "", categoryTitle: "Saved Meals - Organize Your Meals In Categories", selectedId: 0, parentCategory: "default", parentCategoryId: 0, categoryId: 0, grandParentName: "", grandParentId: 0, savedMeals: "", savedCategories: "", search: "", filterSelect: "All", moveCategory: "Category", moveCategoryId: 0, loggedIn: true, redirecting: false, provider: "cox", leadSource: "500", tfn: "772-452-4565", text: "The TransactionID is "};
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeCategory = this.handleChangeCategory.bind(this);
        this.handlePassword = this.handlePassword.bind(this);
        this.login = this.login.bind(this);
        this.createMarkup = this.createMarkup.bind(this);
        this.onSelectAlert = this.onSelectAlert.bind(this);
        this.selectCategory = this.selectCategory.bind(this);
        this.capitalizeWords = this.capitalizeWords.bind(this);
        this.createCategory = this.createCategory.bind(this);
        this.getCategory = this.getCategory.bind(this);
        this.selectToMove = this.selectToMove.bind(this);
        this.updateCategory = this.updateCategory.bind(this);
        this.deleteSavedMeals = this.deleteSavedMeals.bind(this);
        this.changeToTitleEdii = this.changeToTitleEdii.bind(this);
        this.updateCategoryName = this.updateCategoryName.bind(this);
        this.handleChangeCategoryTitle = this.handleChangeCategoryTitle.bind(this);
        this.deleteCategory = this.deleteCategory.bind(this);
        this.deleteCategorySwal = this.deleteCategorySwal.bind(this);
    }

    handleChange(event) {
        this.setState({search: this.capitalizeWords(event.target.value)});
    }

    handleChangeCategory(event) {
        this.setState({category: this.capitalizeWords(event.target.value)});
    }

    handleChangeCategoryTitle(event) {
        this.setState({categoryTitle: this.capitalizeWords(event.target.value)});
    }

    changeToTitleEdii(event) {
        this.setState({titleEdit: !this.state.titleEdit});
    }

    onSelectAlert(eventKey) {
        this.setState({filterSelect: eventKey });
    }

    selectCategory(eventKey) {
        this.setState({moveCategory: eventKey[1] });
        this.setState({moveCategoryId: eventKey[0] });
    }

    handlePassword(e) {
        this.setState({password: e.target.value});
    }

    updateCategoryName(parentId = 0, parentName = "Default", updatedTitle) {
        console.log(parentId);
        if(parentId > 0) {
            var globalThis = this;
            const user = {
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                email: this.state.email,
                phoneNumber: this.state.phoneNumber,
                token: ""
            };

            user.token = localStorage.getItem("mealToken");
            if (user.token != "") {
                //TESTING COMPLETE ORDERS
                $.ajax({
                    url: process.env.REACT_APP_API_HOST + '/' + 'api/auth/user',
                    type: 'get',
                    async: false,
                    'headers': {
                        // Use access_token previously retrieved from inContact token
                        // service.
                        'Authorization': 'Bearer ' + user.token,
                    },
                    error: function (response) {
                        //Failed response
                        // logOrderError(visitID, 'otsError', completeOrderData, response);
                    },
                    success: function (response) {
                        if (typeof(response.message) !== 'undefined') {
                            if (response.message.indexOf('authenticated_user') > -1) {
                                if (typeof(response.data) !== 'undefined') {
                                    $.ajax({
                                        url: process.env.REACT_APP_API_HOST + '/' + 'api/saved/category/name',
                                        type: 'post',
                                        async: false,
                                        data: {
                                            parentId: parentId,
                                            parentName: parentName,
                                            title: updatedTitle,
                                        },
                                        'headers': {
                                            // Use access_token previously retrieved from inContact token
                                            // service.
                                            'Authorization': 'Bearer ' + user.token,
                                        },
                                        error: function (response) {
                                            //Failed response
                                            // logOrderError(visitID, 'otsError', completeOrderData, response);
                                        },
                                        success: function (response) {
                                            if (typeof(response) !== 'undefined') {
                                                globalThis.setState(prevState => ({
                                                    categoryTitle: response.title
                                                }));
                                                globalThis.setState(prevState => ({
                                                    titleEdit: false
                                                }));
                                            }
                                        }
                                    });
                                }
                            }
                        }
                    }
                });
            }
        }
    }

    selectToMove(event) {
        let inSavedMeals = null;
        let tempSavedMeals = this.state.mealsToUpdate;
        let allMealsToSave = document.getElementsByClassName('mealToMove');
        let mealId = event.target.getAttribute('data-meal-id');
        if(mealId !== "") {
            inSavedMeals = tempSavedMeals.includes(mealId);
            if(inSavedMeals === false) {
                tempSavedMeals.push(mealId);
                this.setState({password: tempSavedMeals});
            } else {
                if(tempSavedMeals.length > 0)  {
                    var i = tempSavedMeals.indexOf(mealId);
                    if(i != -1) {
                        tempSavedMeals.splice(i, 1);
                    }
                }
            }
            this.setState({mealsToUpdate: tempSavedMeals});
        }
        console.log(this.state.moveCategory);
        //TODO  - SET CLASS FOR ELEMENT AND IF ELEMENT HASCLASS THEN REMOVE CLASS FROM ELEMENT
            event.target.classList.toggle("mealToMove");
            // if(allMealsToSave.length > 0 && typeof(allMealsToSave) === 'object') {
            //     allMealsToSave = Object.entries(allMealsToSave);
            //     console.log(typeof(allMealsToSave));
            //     allMealsToSave.map((meal, mealIndex) => {
            //         console.log(meal);
            //         console.log(meal['1'].getAttribute('data-meal-id'));
            //     });
            // }
    }

    capitalizeWords(str)
    {
        return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
    }

    deleteSavedMeals(cateName, cateId, parentName, parentId, ids = false, moveCategory = null, moveCategoryId = 0)
    {

        if(ids.length > 0) {
            console.log(cateName+ cateId+ parentName+ parentId);
            console.log("updating category");
            var globalThis = this;
            const user = {
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                email: this.state.email,
                phoneNumber: this.state.phoneNumber,
                token: ""
            };

            user.token = localStorage.getItem("mealToken");
            if (user.token != "") {
                //TESTING COMPLETE ORDERS
                $.ajax({
                    url: process.env.REACT_APP_API_HOST + '/' + 'api/auth/user',
                    type: 'get',
                    async: false,
                    'headers': {
                        // Use access_token previously retrieved from inContact token
                        // service.
                        'Authorization': 'Bearer ' + user.token,
                    },
                    error: function (response) {
                        //Failed response
                        // logOrderError(visitID, 'otsError', completeOrderData, response);
                    },
                    success: function (response) {
                        if (typeof(response.message) !== 'undefined') {
                            if (response.message.indexOf('authenticated_user') > -1) {
                                if (typeof(response.data) !== 'undefined') {
                                    $.ajax({
                                        url: process.env.REACT_APP_API_HOST + '/' + 'api/saved/delete',
                                        type: 'post',
                                        async: false,
                                        data: {
                                            id: cateId,
                                            name: cateName,
                                            parentId: parentId,
                                            parentName: parentName,
                                            savedMeals: JSON.stringify(ids),
                                            moveCategory: moveCategory,
                                            moveCategoryId: moveCategoryId
                                        },
                                        'headers': {
                                            // Use access_token previously retrieved from inContact token
                                            // service.
                                            'Authorization': 'Bearer ' + user.token,
                                        },
                                        error: function (response) {
                                            //Failed response
                                            // logOrderError(visitID, 'otsError', completeOrderData, response);
                                        },
                                        success: function (response) {
                                            console.log(response);
                                            if (typeof(response) !== 'undefined') {
                                                globalThis.setState(prevState => ({
                                                    savedMeals: response.saves
                                                }));
                                                globalThis.setState(prevState => ({
                                                    mealsToUpdate: []
                                                }));
                                            }
                                        }
                                    });
                                }
                            }
                        }
                    }
                });
            }
        }
    }

    deleteCategorySwal(cateId) {
        swal({
            title: "Are you sure?",
            text: "If so, would you like to delete the category and saved meals or just the category. Deleteing category only leaves the saved meals as 'uncategoriezed'",
            buttons: {
                cancel: "Cancel",
                category: {
                    text: "Category",
                    value: "category",
                },
                categoryPlusMeals: {
                    text: "Category & Meals",
                    value: "categoryPlusMeals",
                },
            },
            dangerMode: true,
            icon: "warning",
        })
            .then((value) => {
                switch (value) {
                    case "category":
                    this.deleteCategory(cateId, 1, this.state.grandParentId);
                        break;

                    case "categoryPlusMeals":
                        this.deleteCategory(cateId, 2, this.state.grandParentId);
                        break;

                    default: break;
                }
            });
    }

    deleteCategory( parentId = 0, deleteChoice, grandParentId)
    {
        console.log(parentId);
        if(parentId > 0) {
            console.log( parentId);
            console.log("updating category");
            var globalThis = this;
            const user = {
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                email: this.state.email,
                phoneNumber: this.state.phoneNumber,
                token: ""
            };

            user.token = localStorage.getItem("mealToken");
            if (user.token != "") {
                //TESTING COMPLETE ORDERS
                $.ajax({
                    url: process.env.REACT_APP_API_HOST + '/' + 'api/auth/user',
                    type: 'get',
                    async: false,
                    'headers': {
                        // Use access_token previously retrieved from inContact token
                        // service.
                        'Authorization': 'Bearer ' + user.token,
                    },
                    error: function (response) {
                        //Failed response
                        // logOrderError(visitID, 'otsError', completeOrderData, response);
                    },
                    success: function (response) {
                        if (typeof(response.message) !== 'undefined') {
                            if (response.message.indexOf('authenticated_user') > -1) {
                                if (typeof(response.data) !== 'undefined') {
                                    $.ajax({
                                        url: process.env.REACT_APP_API_HOST + '/' + 'api/category/delete',
                                        type: 'post',
                                        async: false,
                                        data: {
                                            parentId: parentId,
                                            grandParentId: grandParentId,
                                            folderAndContents: deleteChoice,
                                        },
                                        'headers': {
                                            // Use access_token previously retrieved from inContact token
                                            // service.
                                            'Authorization': 'Bearer ' + user.token,
                                        },
                                        error: function (response) {
                                            //Failed response
                                            // logOrderError(visitID, 'otsError', completeOrderData, response);
                                        },
                                        success: function (response) {
                                            console.log("returned");
                                            console.log(response);
                                            if (typeof(response) !== 'undefined') {
                                                globalThis.setState(prevState => ({
                                                    savedCategories: response.category
                                                }));
                                                globalThis.setState(prevState => ({
                                                    savedMeals: response.saves
                                                }));
                                                globalThis.setState(prevState => ({
                                                    category: ''
                                                }));
                                                globalThis.setState(prevState => ({
                                                    categoryId: null
                                                }));
                                                let grandParentId = 0;
                                                let grandParentName = "default";
                                                let parentId = 0;
                                                let parentName = "default";
                                                if(typeof(response.parentCategory) !== 'undefined') {
                                                    if(response.parentCategory !== null) {
                                                        grandParentId = response.parentCategory.parent_category_id;
                                                        grandParentName = response.parentCategory.parent_category;
                                                        if(response.parentCategory !== null) {
                                                            parentName = response.parentCategory.category;
                                                            parentId = response.parentCategory.id;
                                                        }
                                                    }
                                                }
                                                if(parentName === "default") {
                                                    globalThis.setState(prevState => ({
                                                        categoryTitle: "Saved Meals - Organize Your Meals In Categories"
                                                    }));
                                                } else {
                                                    globalThis.setState(prevState => ({
                                                        categoryTitle: parentName
                                                    }));
                                                }
                                                console.log("change parent");
                                                console.log(parentId);
                                                globalThis.setState(prevState => ({
                                                    parentCategory: parentName
                                                }));
                                                globalThis.setState(prevState => ({
                                                    parentCategoryId: parentId
                                                }));
                                                globalThis.setState(prevState => ({
                                                    grandParentId: grandParentId
                                                }));
                                                globalThis.setState(prevState => ({
                                                    grandParent: grandParentName
                                                }));


                                            }
                                        }
                                    });
                                }
                            }
                        }
                    }
                });
            }
        }
    }

    updateCategory(cateName, cateId, parentName, parentId, ids = false, moveCategory = null, moveCategoryId = 0)
    {

        if(ids.length > 0) {
            console.log(cateName+ cateId+ parentName+ parentId);
            console.log("updating category");
            var globalThis = this;
            const user = {
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                email: this.state.email,
                phoneNumber: this.state.phoneNumber,
                token: ""
            };

            user.token = localStorage.getItem("mealToken");
            if (user.token != "") {
                //TESTING COMPLETE ORDERS
                $.ajax({
                    url: process.env.REACT_APP_API_HOST + '/' + 'api/auth/user',
                    type: 'get',
                    async: false,
                    'headers': {
                        // Use access_token previously retrieved from inContact token
                        // service.
                        'Authorization': 'Bearer ' + user.token,
                    },
                    error: function (response) {
                        //Failed response
                        // logOrderError(visitID, 'otsError', completeOrderData, response);
                    },
                    success: function (response) {
                        if (typeof(response.message) !== 'undefined') {
                            if (response.message.indexOf('authenticated_user') > -1) {
                                if (typeof(response.data) !== 'undefined') {
                                    $.ajax({
                                        url: process.env.REACT_APP_API_HOST + '/' + 'api/saved/update',
                                        type: 'post',
                                        async: false,
                                        data: {
                                            id: cateId,
                                            name: cateName,
                                            parentId: parentId,
                                            parentName: parentName,
                                            savedMeals: JSON.stringify(ids),
                                            moveCategory: moveCategory,
                                            moveCategoryId: moveCategoryId
                                        },
                                        'headers': {
                                            // Use access_token previously retrieved from inContact token
                                            // service.
                                            'Authorization': 'Bearer ' + user.token,
                                        },
                                        error: function (response) {
                                            //Failed response
                                            // logOrderError(visitID, 'otsError', completeOrderData, response);
                                        },
                                        success: function (response) {
                                            console.log(response);
                                            if (typeof(response) !== 'undefined') {
                                                globalThis.setState(prevState => ({
                                                    savedMeals: response.saves
                                                }));
                                                globalThis.setState(prevState => ({
                                                    mealsToUpdate: []
                                                }));
                                                let allMealsToSave = document.getElementsByClassName('mealToMove');
                                                if(allMealsToSave.length > 0 && typeof(allMealsToSave) === 'object') {
                                                    allMealsToSave = Object.entries(allMealsToSave);
                                                    console.log(typeof(allMealsToSave));
                                                    allMealsToSave.map((meal, mealIndex) => {
                                                        if(meal['1']) {
                                                            meal['1'].classList.remove("mealToMove");
                                                        }
                                                    });
                                                }
                                            }
                                        }
                                    });
                                }
                            }
                        }
                    }
                });
            }
        }
    }

    createCategory(cateName, cateId, parentName, parentId)
    {
        if(cateName !== "") {
            console.log(cateName+ cateId+ parentName+ parentId);
            console.log("creating category");

            var globalThis = this;
            const user = {
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                email: this.state.email,
                phoneNumber: this.state.phoneNumber,
                token: ""
            };

            user.token = localStorage.getItem("mealToken");
            if (user.token != "") {
                //TESTING COMPLETE ORDERS
                $.ajax({
                    url: process.env.REACT_APP_API_HOST + '/' + 'api/auth/user',
                    type: 'get',
                    async: false,
                    'headers': {
                        // Use access_token previously retrieved from inContact token
                        // service.
                        'Authorization': 'Bearer ' + user.token,
                    },
                    error: function (response) {
                        //Failed response
                        // logOrderError(visitID, 'otsError', completeOrderData, response);
                    },
                    success: function (response) {
                        if (typeof(response.message) !== 'undefined') {
                            if (response.message.indexOf('authenticated_user') > -1) {
                                if (typeof(response.data) !== 'undefined') {
                                    $.ajax({
                                        url: process.env.REACT_APP_API_HOST + '/' + 'api/category/create/' + cateName,
                                        type: 'post',
                                        async: false,
                                        data: {
                                            id: cateId,
                                            name: cateName,
                                            parentId: parentId,
                                            parentName: parentName
                                        },
                                        'headers': {
                                            // Use access_token previously retrieved from inContact token
                                            // service.
                                            'Authorization': 'Bearer ' + user.token,
                                        },
                                        error: function (response) {
                                            //Failed response
                                            // logOrderError(visitID, 'otsError', completeOrderData, response);
                                        },
                                        success: function (response) {
                                            console.log(response);
                                            if (typeof(response) !== 'undefined') {
                                                globalThis.setState(prevState => ({
                                                    savedCategories: response.category
                                                }));
                                                globalThis.setState(prevState => ({
                                                    savedMeals: response.saves
                                                }));

                                            }
                                        }
                                    });
                                }
                            }
                        }
                    }
                });
            }
        }
    }

    getCategory(cateName, cateId, parentName, parentId, back = false)
    {
        console.log(cateName+ cateId+ parentName+ parentId);
        if(cateName !== "") {

            var globalThis = this;
            const user = {
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                email: this.state.email,
                phoneNumber: this.state.phoneNumber,
                token: ""
            };

            user.token = localStorage.getItem("mealToken");
            if (user.token != "") {
                //TESTING COMPLETE ORDERS
                $.ajax({
                    url: process.env.REACT_APP_API_HOST + '/' + 'api/auth/user',
                    type: 'get',
                    async: false,
                    'headers': {
                        // Use access_token previously retrieved from inContact token
                        // service.
                        'Authorization': 'Bearer ' + user.token,
                    },
                    error: function (response) {
                        //Failed response
                        // logOrderError(visitID, 'otsError', completeOrderData, response);
                    },
                    success: function (response) {
                        if (typeof(response.message) !== 'undefined') {
                            if (response.message.indexOf('authenticated_user') > -1) {
                                if (typeof(response.data) !== 'undefined') {
                                    $.ajax({
                                        url: process.env.REACT_APP_API_HOST + '/' + 'api/category/show',
                                        type: 'post',
                                        async: false,
                                        data: {
                                            id: cateId,
                                            name: cateName,
                                            parentId: parentId,
                                            parentName: parentName,
                                            back: back
                                        },
                                        'headers': {
                                            // Use access_token previously retrieved from inContact token
                                            // service.
                                            'Authorization': 'Bearer ' + user.token,
                                        },
                                        error: function (response) {
                                            //Failed response
                                            // logOrderError(visitID, 'otsError', completeOrderData, response);
                                        },
                                        success: function (response) {
                                            if (typeof(response) !== 'undefined') {
                                                console.log("printing category");
                                                console.log(response.category_parent[0]);
                                                let grandParentCategory = null;
                                                let grandParentCategoryId = null;
                                                let parentCategory = null;
                                                let parentCategoryId = null;
                                                let categoryTitle = null;
                                                if (typeof(response.category_parent) !== 'undefined') {
                                                            if(response.category_parent.constructor === Array) {
                                                                response.category_parent.map((category, cateIndex) => {
                                                                    if(cateIndex === 0) {
                                                                        if(typeof(category.parent_category) !== "undefined") {
                                                                            grandParentCategory = category.parent_category;
                                                                        }
                                                                        if(typeof(category.parent_category_id) !== "undefined") {
                                                                            grandParentCategoryId = category.parent_category_id;
                                                                        }
                                                                        if(typeof(category.category) !== "undefined") {
                                                                            categoryTitle = category.category;
                                                                        }
                                                                        if(typeof(category.category) !== "undefined") {
                                                                            parentCategory = category.category;
                                                                        }
                                                                        if(typeof(category.category) !== "undefined") {
                                                                            parentCategoryId = category.id;
                                                                        }
                                                                    }
                                                                });
                                                            }
                                                }
                                                if (typeof(response.category) !== 'undefined') {
                                                    if(response.category.constructor === Array) {
                                                        response.category.map((category, cateIndex) => {
                                                            if(cateIndex === 0) {
                                                                if(typeof(category.parent_category) !== "undefined") {
                                                                    parentCategory = category.parent_category;
                                                                }
                                                                if(typeof(category.parent_category_id) !== "undefined") {
                                                                    parentCategoryId = category.parent_category_id;
                                                                }
                                                            }
                                                        });
                                                    }
                                                }
                                                globalThis.setState(prevState => ({
                                                    savedCategories: response.category
                                                }));
                                                globalThis.setState(prevState => ({
                                                    savedMeals: response.saves
                                                }));
                                                globalThis.setState(prevState => ({
                                                    category: ''
                                                }));
                                                globalThis.setState(prevState => ({
                                                    categoryId: null
                                                }));
                                                globalThis.setState(prevState => ({
                                                    parentCategory: parentCategory
                                                }));
                                                globalThis.setState(prevState => ({
                                                    categoryTitle: categoryTitle
                                                }));
                                                globalThis.setState(prevState => ({
                                                    parentCategoryId: parentCategoryId
                                                }));
                                                // globalThis.setState(prevState => ({
                                                //     categoryTitle: cateName
                                                // }));
                                                globalThis.setState(prevState => ({
                                                    grandParentName: grandParentCategory
                                                }));
                                                globalThis.setState(prevState => ({
                                                    grandParentId: grandParentCategoryId
                                                }));
                                            }
                                        }
                                    });
                                }
                            }
                        }
                    }
                });
            }
        }
    }

    login(e) {
        const customer = {
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            email: this.state.email,
            phoneNumber: this.state.phoneNumber
        };

        $.ajax({
            url: process.env.REACT_APP_API_HOST + '/' + 'api/auth/login',
            type: 'post',
            async: false,
            data: {
                email: this.state.email,
                password: this.state.password
            },
            error: function (response) {
                //Failed response
                // logOrderError(visitID, 'otsError', completeOrderData, response);
            },
            success: function (response) {
                console.log(response);
                // this.setState(prevState => ({
                //     redirecting: <Redirect to="/confirmation"/>
                // }));
            }
        });

    }

    createMarkup(text) {
        return {__html: text};
    }

    componentDidMount() {
        // if(this.state.provider != "") {
        //     require('../assets/css/' + this.state.provider + '.css');
        // }
        var globalThis = this;
        const user = {
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            email: this.state.email,
            phoneNumber: this.state.phoneNumber,
            token: ""
        };

        user.token = localStorage.getItem("mealToken");
        const parentId = this.state.parentCategoryId;
        if(user.token != "" ) {
            //TESTING COMPLETE ORDERS
            $.ajax({
                url: process.env.REACT_APP_API_HOST + '/' + 'api/auth/user',
                type: 'get',
                async: false,
                'headers': {
                    // Use access_token previously retrieved from inContact token
                    // service.
                    'Authorization': 'Bearer ' + user.token,
                },
                error: function (response) {
                    //Failed response
                    // logOrderError(visitID, 'otsError', completeOrderData, response);
                },
                success: function (response) {
                    if(typeof(response.message) !== 'undefined') {
                        if(response.message.indexOf('authenticated_user') > -1) {
                            if (typeof(response.data) !== 'undefined') {
                                if (typeof(response.data.id) !== 'undefined') {

                                } else {
                                    globalThis.setState(prevState => ({
                                        loggedIn: false
                                    }));
                                }
                                $.ajax({
                                    url: process.env.REACT_APP_API_HOST + '/' + 'api/mealtrist/saves/' + response.data.id,
                                    type: 'post',
                                    async: false,
                                    data: {
                                        parentId: parentId
                                    },
                                    'headers': {
                                        // Use access_token previously retrieved from inContact token
                                        // service.
                                        'Authorization': 'Bearer ' + user.token,
                                    },
                                    error: function (response) {
                                        //Failed response
                                        // logOrderError(visitID, 'otsError', completeOrderData, response);
                                    },
                                    success: function (response) {
                                        console.log(response.meals);
                                        if(typeof(response) !== 'undefined') {
                                            globalThis.setState(prevState => ({
                                                meals: response.meals
                                            }));
                                            globalThis.setState(prevState => ({
                                                profile: response.profile
                                            }));
                                            globalThis.setState(prevState => ({
                                                savedMeals: response.saves
                                            }));
                                            globalThis.setState(prevState => ({
                                                savedCategories: response.category
                                            }));
                                        }
                                    }
                                });
                            }
                        }
                    }
                }
            });
        }

    }

    //TODO set referrer url link in containers first child link
    render() {
        const { width, height } = this.props.size;
        const grid = {
            update: ""
        }
        const fakeArr = ["d", "a"];
        const pictures = fakeArr.map((imgPath, pathIndex) => {
            return  <div key={imgPath}><img src="https://tsuyoshiwada.github.io/react-stack-grid/images/photos/photo03.jpg" /></div>
        });
        const header = {
            use: ""
        }
        if(this.state.loggedIn === true) {
            header.use = <MealtristHeader/>;
        } else {
            header.use = <MainHeader/>;
        }

        let output =
            <div>
                {header.use}
                <div className="text-center main-body-content">
                    <i className="fa fa-spinner fa-pulse fa-3x fa-fw loading-logo"></i>
                </div>
                <MealtristFooter/>
            </div>
            const profile = {
                data: ""
            }

            let savedCategories = null;
            console.log("print meals first");
            console.log(this.state.meals);
            if(this.state.meals != "" || typeof(this.state.meals) !== 'array') {
                if(this.state.profile != "") {
                    profile.data = this.state.profile;
                }
                if(this.state.savedCategories !== "") {
                    console.log(this.state.savedCategories);
                    savedCategories = this.state.savedCategories.map((category, cateIndex) => {
                        return <div className="col-xm-3" key={category.category+category.id}>
                            <i className="fa fa-folder fa-3x" onClick={this.getCategory.bind(this, category.category, category.id, category.parent_category, category.parent_category_id, false)} aria-hidden="true"></i>
                            <p>{category.category}</p>
                        </div>
                    });
                }
                const mealsData = {
                    data: ""
                }
                let category_dropdown = null;
                if(this.state.savedMeals.length > 0) {
                    let filteredMeals = this.state.savedMeals.filter((meal) => meal.name.toLowerCase().indexOf(this.state.search) > -1);

                    if (this.state.filterSelect.toLowerCase() !== "all") {
                        console.log("in first");
                        console.log(this.state.filterSelect);
                        filteredMeals = filteredMeals.filter((meal) => meal.course.toLowerCase().indexOf(this.state.filterSelect) > -1);
                    } else {
                        console.log(this.state.filterSelect);
                        console.log("filtered");
                        filteredMeals = filteredMeals.filter((meal) => meal.course !== "");
                    }

                    if(this.state.savedCategories !== "" && this.state.mealsToUpdate.length > 0) {
                        console.log(this.state.savedCategories);
                        let get_categories = this.state.savedCategories.map((category, cateIndex) => {

                                return <ReactBootstrap.MenuItem eventKey={[category.id, category.category]}
                                                                onSelect={this.selectCategory}>{category.category}</ReactBootstrap.MenuItem>
                        });
                        let prependGrandParent = "";
                        let prependMain = "";
                        console.log("grandparent id = " + this.state.grandParentId);
                        prependMain = <ReactBootstrap.MenuItem eventKey={[0, "main"]} onSelect={this.selectCategory}>{"main"}</ReactBootstrap.MenuItem>
                        if(this.state.grandParentId != 0) {
                            prependGrandParent = <ReactBootstrap.MenuItem eventKey={[this.state.grandParentId, this.state.grandParentName]} onSelect={this.selectCategory}>{this.state.grandParentName}</ReactBootstrap.MenuItem>;
                        }

                      category_dropdown =<div className="col-sm-12"><div className="col-sm-3"><ReactBootstrap.Form horizontal>
                            <ReactBootstrap.FormGroup bsSize="large" controlId="formHorizontalEmail">
                                <ReactBootstrap.SplitButton title={this.capitalizeWords(this.state.moveCategory)} pullRight id="split-button-pull-right" bsSize="large">
                                    {prependMain}
                                    {prependGrandParent}
                                    {get_categories}
                                </ReactBootstrap.SplitButton>
                            </ReactBootstrap.FormGroup>
                        </ReactBootstrap.Form>
                      </div>
                          <div className="col-xs-3">
                              <ReactBootstrap.ButtonToolbar>
                                  <ReactBootstrap.Button bsSize="large" onClick={this.updateCategory.bind(this, this.state.category, this.state.categoryId, this.state.parentCategory, this.state.parentCategoryId, this.state.mealsToUpdate, this.state.moveCategory, this.state.moveCategoryId)}>Move Meals</ReactBootstrap.Button>
                              </ReactBootstrap.ButtonToolbar>
                          </div>
                          <div className="col-xs-3">
                              <ReactBootstrap.ButtonToolbar>
                                  <ReactBootstrap.Button bsSize="large" onClick={this.deleteSavedMeals.bind(this, this.state.category, this.state.categoryId, this.state.parentCategory, this.state.parentCategoryId, this.state.mealsToUpdate, this.state.moveCategory, this.state.moveCategoryId)}>
                                      <span>Delete Meal</span>
                                      {this.state.mealsToUpdate.length > 1 &&
                                      <span>s</span>
                                      }
                                  </ReactBootstrap.Button>
                              </ReactBootstrap.ButtonToolbar>
                          </div>
                      </div>
                    } else {
                         category_dropdown = "";
                    }
                    mealsData.data = filteredMeals.map((meal, mealIndex) => {
                            return <div key={mealIndex}>
                                <img data-meal-id={meal.meal_id}
                                     className={"center-block img-responsive" + this.state.mealToMoveClass}
                                     src={ meal.picture}
                                     onClick={(event) => this.selectToMove(event)}/>
                                <h4 className="text-center"><Link to={'meal-show/' + meal.meal_id}>{meal.name}</Link></h4>
                                <p dangerouslySetInnerHTML={this.createMarkup(meal.description)}></p>
                            </div>
                    });
                }
                let back = "";
                if(this.state.parentCategory !== "default") {
                    back = <i className="fa fa-reply fa-2x" onClick={this.getCategory.bind(this, this.state.grandParentName, this.state.grandParentId, this.state.grandParentName, this.state.grandParentId, "back")}></i>
                }

                output = <div>
                    <div className="container main-body-content">
                        {header.use}
                        {this.state.parentCategory !== "default" &&
                        <div className="row">
                            <div className="col-sm-9">
                                    {back}
                            </div>
                            <div className="col-sm-3">
                                <div className="col-sm-12">
                                    <div className="col-sm-6">

                                    </div>
                                    <div className="col-sm-6">
                                        <ReactBootstrap.ButtonToolbar>
                                            <ReactBootstrap.Button bsSize="small" onClick={this.deleteCategorySwal.bind(this, this.state.parentCategoryId)}>Delete Category</ReactBootstrap.Button>
                                        </ReactBootstrap.ButtonToolbar>
                                    </div>
                                </div>
                            </div>
                        </div>
                        }
                        {(this.state.titleEdit === false && this.state.parentCategory !== "default") &&
                        <h2 className="text-center" onClick={this.changeToTitleEdii}>{this.state.categoryTitle}</h2>
                        }
                        {(this.state.titleEdit === false && this.state.parentCategory === "default") &&
                        <h2 className="text-center">{this.state.categoryTitle}</h2>
                        }
                        {this.state.titleEdit === true &&
                        <div className="row">
                            <div className="col-sm-3">
                            </div>
                            <div className="col-xs-3">
                                <ReactBootstrap.Form horizontal>
                                    <ReactBootstrap.FormGroup bsSize="large" controlId="formHorizontalCategory">
                                        <ReactBootstrap.FormControl type="text" value={this.state.categoryTitle} onChange={this.handleChangeCategoryTitle} />
                                    </ReactBootstrap.FormGroup>
                                </ReactBootstrap.Form>
                            </div>
                            <div className="col-xs-3">
                            <ReactBootstrap.ButtonToolbar>
                                <ReactBootstrap.Button bsSize="large" onClick={this.updateCategoryName.bind(this, this.state.parentCategoryId, this.state.parentCategory, this.state.categoryTitle)}>Update Category</ReactBootstrap.Button>
                            </ReactBootstrap.ButtonToolbar>
                        </div>
                            <div className="col-xs-3">
                                <ReactBootstrap.ButtonToolbar>
                                    <ReactBootstrap.Button bsSize="large" onClick={this.changeToTitleEdii}>Cancel</ReactBootstrap.Button>
                                </ReactBootstrap.ButtonToolbar>
                            </div>
                        </div>
                        }
                        <div className="row">
                            <div className="col-xs-6">
                                <ReactBootstrap.Form horizontal>
                                    <ReactBootstrap.FormGroup bsSize="large" controlId="formHorizontalCategory">
                                        <ReactBootstrap.FormControl type="text" value={this.state.category} onChange={this.handleChangeCategory} placeholder="Create Category" />
                                    </ReactBootstrap.FormGroup>
                                </ReactBootstrap.Form>
                            </div>
                            <div className="col-xs-6">
                                <ReactBootstrap.ButtonToolbar>
                                    <ReactBootstrap.Button bsSize="large" onClick={this.createCategory.bind(this, this.state.category, this.state.categoryId, this.state.parentCategory, this.state.parentCategoryId)}>Create Category</ReactBootstrap.Button>
                                </ReactBootstrap.ButtonToolbar>
                            </div>
                        </div>
                        <div classNmae="row">
                            <StackGrid
                                columnWidth={"25%"}
                                monitorImagesLoaded="{true}"
                                // duration={0}
                            >
                                {savedCategories}

                            </StackGrid>

                        </div>
                        <h3 className="text-center">Uncategorized Meals</h3>
                        <div className="row">
                            <div className="col-xs-6">
                                <ReactBootstrap.Form horizontal>
                                    <ReactBootstrap.FormGroup bsSize="large" controlId="formHorizontalSearch">
                                    <ReactBootstrap.FormControl type="text" value={this.state.search} onChange={this.handleChange} placeholder="Search Meals" />
                                    </ReactBootstrap.FormGroup>
                                </ReactBootstrap.Form>
                            </div>
                            <div className="col-xs-6">
                                <ReactBootstrap.Form horizontal>
                                    <ReactBootstrap.FormGroup bsSize="large" controlId="formHorizontalEmail">
                                        <ReactBootstrap.SplitButton title={this.capitalizeWords(this.state.filterSelect)} pullRight id="split-button-pull-right" bsSize="large">
                                        <ReactBootstrap.MenuItem eventKey={'all'} onSelect={this.onSelectAlert}>All</ReactBootstrap.MenuItem>
                                        <ReactBootstrap.MenuItem eventKey="main dishes" onSelect={this.onSelectAlert}>Main Dishes</ReactBootstrap.MenuItem>
                                        <ReactBootstrap.MenuItem eventKey="appetizer" onSelect={this.onSelectAlert}>Appetizer</ReactBootstrap.MenuItem>
                                        <ReactBootstrap.MenuItem eventKey="beverages" onSelect={this.onSelectAlert}>Beverages</ReactBootstrap.MenuItem>
                                        <ReactBootstrap.MenuItem eventKey="breads" onSelect={this.onSelectAlert}>Breads</ReactBootstrap.MenuItem>
                                        <ReactBootstrap.MenuItem eventKey="desserts" onSelect={this.onSelectAlert}>Desserts</ReactBootstrap.MenuItem>
                                        <ReactBootstrap.MenuItem eventKey="finger foods" onSelect={this.onSelectAlert}>Finger Foods</ReactBootstrap.MenuItem>
                                        <ReactBootstrap.MenuItem eventKey="salads" onSelect={this.onSelectAlert}>Salads</ReactBootstrap.MenuItem>
                                        <ReactBootstrap.MenuItem eventKey="side dishes" onSelect={this.onSelectAlert}>Side Dishes</ReactBootstrap.MenuItem>
                                        <ReactBootstrap.MenuItem eventKey="snacks" onSelect={this.onSelectAlert}>Snacks</ReactBootstrap.MenuItem>
                                        <ReactBootstrap.MenuItem eventKey="soups and stew" onSelect={this.onSelectAlert}>Soups & Stew</ReactBootstrap.MenuItem>
                                        <ReactBootstrap.MenuItem divider />
                                        <ReactBootstrap.MenuItem eventKey="4">Separated link</ReactBootstrap.MenuItem>
                                    </ReactBootstrap.SplitButton>
                                    </ReactBootstrap.FormGroup>
                                </ReactBootstrap.Form>
                            </div>
                        </div>
                        <div className="row">
                            <h2 className="text-center">Click meal pictures in order to mark them and move to another folder.</h2>
                            {this.state.mealsToUpdate.length > 0 &&
                            <h2 className="text-center">Choose a category you would like to move meals into.</h2>
                            }
                            {category_dropdown}
                        </div>
                <StackGrid
                    columnWidth={width <= 768 ? '50%' : '25%' || '25%'}
                    monitorImagesLoaded="{true}"
                    // duration={0}
                >
                    {mealsData.data}
                    {/*{pictures}*/}
                    {/*<div key="key1"><img src="https://tsuyoshiwada.github.io/react-stack-grid/images/photos/photo03.jpg" /></div>*/}
                    {/*<div key="key2"><img src="https://tsuyoshiwada.github.io/react-stack-grid/images/photos/photo02.jpg" /></div>*/}
                    {/*<div key="key3"><img src="https://tsuyoshiwada.github.io/react-stack-grid/images/photos/photo03.jpg" /> </div>*/}
                    {/*<div key="key4"><img src="https://tsuyoshiwada.github.io/react-stack-grid/images/photos/photo02.jpg" /></div>*/}
                    {/*<div key="key5"><img src="https://tsuyoshiwada.github.io/react-stack-grid/images/photos/photo03.jpg" /></div>*/}
                    {/*<div key="key6"><img src="https://tsuyoshiwada.github.io/react-stack-grid/images/photos/photo02.jpg" /></div>*/}
                    {/*<div key="key7"><img src="https://tsuyoshiwada.github.io/react-stack-grid/images/photos/photo03.jpg" /> </div>*/}

                </StackGrid>
                    </div>
                    <MealtristFooter/>
                </div>
            }
        // console.log("print grid");
        // console.log(grid.update);
        // if(grid.update !== "") {
        //     console.log("grid updating");
        //     console.log(grid.update);
        //     grid.update.updateLayout();
        // }
        return (

                output

        );
    }
}

export default sizeMe()(Saved);


// WEBPACK FOOTER //
// ./src/components/Mealtrist/saved.js